import Progress from 'redux-progress';

import { Selector, State } from 'model/State';
import { AccountDetail } from '../models';

export const selectDetails: (state: State, accountId: string) => AccountDetail = (
  state: State,
  accountId: string,
) => state.mac.accounts.details?.[accountId]?.ifSuccess((r) => r);

export const selectDetailsProgress: (state: State, accountId: string) => Progress<AccountDetail> = (
  state: State,
  accountId: string,
) => state.mac.accounts.details?.[accountId];

export const selectDetailsGeneralObject: Selector<object> = (state: State) =>
  state.mac.accounts.details;

export const selectIsUpgradableAccount = (state: State, accountId: number) =>
  state.mac.accounts.isUpgradableAccount?.[accountId]?.ifSuccess((r) => r);

export const selectIsRenewableAccount = (state: State, accountId: number) =>
  state.mac.accounts.isRenewableAccount?.[accountId]?.ifSuccess((r) => r);

export const selectIsEvaluationAllowed: Selector<boolean | null> = (state: State) =>
  state.mac.accounts.isEvaluationAllowed?.ifSuccess((r) => r);

export const selectAsyncCustomerAccountOverviewsByPartnerSearchDTO: Selector<string | null> = (
  state,
) =>
  state.mac.accounts.getAsyncCustomerAccountOverviewsByPartnerSearchDTO.ifSuccess((r) => r || null);

export const selectNewContact = (state: State) =>
  state.mac.accounts.newContact?.ifSuccess((r) => r);

export const selectNewContactProgress = (state: State) => state.mac.accounts.newContact;

export const selectValidateContactProgress = (state: State) => state.mac.accounts.validateContact;

export const selectValidateContactResult = (state: State) =>
  state.mac.accounts.validateContact?.ifSuccess((r) => r);

export const selectMakeContactPrimaryProgress = (state: State) =>
  state.mac.accounts.makeContactPrimary;

export const selectMakeContactPrimaryResult = (state: State) =>
  state.mac.accounts.makeContactPrimary?.ifSuccess((r) => r);

export const selectEndUserCSVDownloadInProgress = (state: State) =>
  state.mac.accounts.endUserCSVDownloadInProgress;

export const selectEndUserCSVDownloadIsMigrationInProgress = (state: State) =>
  state.mac.accounts.endUserCSVDownloadIsMigrationInProgress;

export const selectAppParentSen = (state: State) => state.mac.accounts.getAppParentSen;

export const selectUpdatedAppParentSen = (state: State) => state.mac.accounts.postAppParentSen;

export const selectUploadDcAppParentMappingProgress = (state: State) =>
  state.mac.accounts.uploadDcAppParentMapping;

export const selectUploadDcAppParentMappingInProgress = (state: State) =>
  state.mac.accounts.uploadDcAppParentMapping?.inProgress ?? false;

export const selectUploadDcAppParentMappingResult = (state: State) =>
  state.mac.accounts.uploadDcAppParentMapping?.ifSuccess((r) => r) ?? null;
